import { useEffect, type ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "@/src/redux/hooks";
import { clearBaseData } from "@/src/redux/slices/baseDataSlice";
import { getAppStoreApi } from "@/src/redux/storeClient";
import { refreshCategoryChildren } from "@/src/services/categoryChildrenRefresh";

export function BaseDataProvider({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const { isAuthenticated, accessToken, user } = useAppSelector((state) => state.auth);
  const { fetchedForUserId, loading } = useAppSelector((state) => state.baseData);

  const userId = user?.id ?? null;

  useEffect(() => {
    if (!isAuthenticated || !accessToken || !userId) {
      dispatch(clearBaseData());
      return;
    }

    if (fetchedForUserId === userId || loading) {
      return;
    }

    const { store } = getAppStoreApi();
    void refreshCategoryChildren(dispatch, store.getState);
  }, [accessToken, dispatch, fetchedForUserId, isAuthenticated, loading, userId]);

  return <>{children}</>;
}
